export namespace PersonalsData {
  export interface IPersonalData {
    id: number;
    name: string;
    surname: string;
    genre: number;
    birthDate: string;
    nickname: string;
    imageUrl: string;
    photoURL: string;
    smallImgUrl: string;
    bio: string;
  }

  export class PersonalData implements IPersonalData {
    id: number = 0;
    name: string = "";
    surname: string = "";
    genre: number = 0;
    birthDate: string = "";
    nickname: string = "";
    imageUrl: string = "";
    photoURL: string = "";
    smallImgUrl: string = "";
    bio: string = "";
  }
}
